import { render, staticRenderFns } from "./FormRequestViewer.vue?vue&type=template&id=11ffcb4c&scoped=true&"
import script from "./FormRequestViewer.vue?vue&type=script&lang=js&"
export * from "./FormRequestViewer.vue?vue&type=script&lang=js&"
import style0 from "./FormRequestViewer.vue?vue&type=style&index=0&id=11ffcb4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ffcb4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11ffcb4c')) {
      api.createRecord('11ffcb4c', component.options)
    } else {
      api.reload('11ffcb4c', component.options)
    }
    module.hot.accept("./FormRequestViewer.vue?vue&type=template&id=11ffcb4c&scoped=true&", function () {
      api.rerender('11ffcb4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/forms/FormRequestViewer.vue"
export default component.exports